const isReactSnap = () => {
    // Check if we're in a server-side rendering environment
    if (typeof window === "undefined") return true;
  
    // Check if we're in a static generation environment
    if (typeof navigator === "undefined") return true;
  
    // Check for react-snap user agent
    if (navigator.userAgent && navigator.userAgent.includes("ReactSnap")) return true;
  
    // Check for headless browser indicators
    if (navigator.webdriver) return true;
  
    // Check for puppeteer indicators
    if (window.navigator && window.navigator.webdriver) return true;
  
    // Check if we're in a build environment
    if (process.env.NODE_ENV === "production" && !window.location.hostname) return true;
  
    return false;
  };
  
  export default isReactSnap;
  